import React from 'react';
import { Section } from './ui/Section';
import { BookOpenIcon, CalendarIcon, ClockIcon, FileTextIcon, HelpCircleIcon } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: BookOpenIcon,
    text: 'El libro digital completo Sueño y Serenidad (paso a paso)'
  }, {
    icon: CalendarIcon,
    text: 'El Plan de Implementación de 7 Días'
  }, {
    icon: ClockIcon,
    text: 'El Protocolo para Despertares de 2–4am'
  }, {
    icon: FileTextIcon,
    text: 'Imprimibles: Lista de Reinicio Nocturno + Tarjetas de Guía + Ejercicios de Escritura'
  }, {
    icon: HelpCircleIcon,
    text: 'Preguntas frecuentes + soluciones para que no abandones después de una mala noche'
  }];
  return <Section className="bg-cream-50" dark={false} data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <h2 className="text-3xl md:text-4xl font-serif text-navy-900 mb-12 text-center" data-id="element-153">
          Lo que recibirás{' '}
          <span className="italic text-navy-600" data-id="element-154">(qué incluye)</span>
        </h2>

        <div className="bg-white rounded-3xl shadow-xl border border-cream-200 overflow-hidden" data-id="element-155">
          <div className="divide-y divide-cream-100" data-id="element-156">
            {items.map((item, index) => <div key={index} className="p-6 md:p-8 flex items-start gap-6 hover:bg-cream-50/50 transition-colors" data-id="element-157">
                <div className="flex-shrink-0 w-12 h-12 bg-navy-50 rounded-full flex items-center justify-center text-navy-900" data-id="element-158">
                  <item.icon className="w-6 h-6" data-id="element-159" />
                </div>
                <div className="flex items-center min-h-[3rem]" data-id="element-160">
                  <p className="text-lg text-navy-800 font-medium" data-id="element-161">
                    {item.text}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}